import { render, staticRenderFns } from "./JcomPaymentReport.vue?vue&type=template&id=840f3220"
import script from "./JcomPaymentReport.vue?vue&type=script&lang=js"
export * from "./JcomPaymentReport.vue?vue&type=script&lang=js"
import style0 from "./JcomPaymentReport.vue?vue&type=style&index=0&id=840f3220&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports